/* eslint-disable */
import {get} from 'lodash'

export enum ChangeTypes {
  value='value',
  disable='disable'
}

type ColorList = Array<string>;
// eslint-disable-next-line import/prefer-default-export
export const HIGHLIGHT_COLORS: ColorList = ['#E89B2F', '#F07DE8', '#859BFF', '#78EBD6', '#CBE655']
export const PANEL_COLORS: ColorList =['#E89B2F', '#F07DE8', '#859BFF', '#78EBD6', '#CBE655', '#2CD58D','#A863F7','#96E655','#DE3E4E','#1976D2']
export const MAX_HIGHLIGHT_COUNT = 10


type simplifiedHighlightItemInfo = {
  value: string,
  [key:number]: any
}

export type HighlightItemInfo = {
  color: string,
  value:string,
  disabled: boolean
}

export type HighlightListModel = Array<HighlightItemInfo>;

export function fulFillHighlightListModel(
  simplifiedArray: simplifiedHighlightItemInfo[] | string[],
  customOverwrite: {[key:number]: any},
  colorList:ColorList = HIGHLIGHT_COLORS,
):HighlightListModel {
  const looper:Array<simplifiedHighlightItemInfo|HighlightItemInfo|string> = simplifiedArray.length > 0 ? simplifiedArray : colorList;
  return looper.map((x, idx) => {
    const value = get(simplifiedArray, `${idx}.value`)
    return Object.assign({
      color: get(simplifiedArray, `${idx}.color`, colorList[idx]),
      value: (typeof get(simplifiedArray, `${idx}`) === 'string' ? get(simplifiedArray, `${idx}`) : value) || '',
      disabled: !!get(simplifiedArray, `${idx}.disabled`),
    }, customOverwrite)
  })
}

function isAllByStatementFunction(
  list:Array<any>,
  validEachFunction:(any) => boolean,
  breakCall:(Boolean) => boolean,
):boolean {
  let ret = false
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < list.length; i++) {
    const info = list[i]
    ret = validEachFunction(info)
    if (breakCall(ret)) {
      break
    }
  }
  return ret
}

export function isAllDisabled(list:HighlightListModel):boolean {
  return isAllByStatementFunction(list, info => info.disabled, disabled => disabled === false)
}

export function isAllEmpty(list:HighlightListModel):Boolean {
  const isEmptyValue = info => !info.value
  return isAllByStatementFunction(list, info => isEmptyValue(info), isEmpty => isEmpty === false)
}

export function isAllValid(list:Array<any>):Boolean {
  if(!Array.isArray(list)){
    return false
  }
  const isValid = info => info && typeof info.value === 'string' && (typeof info.disabled === 'boolean') && typeof info.color === 'string';
  return isAllByStatementFunction(list, isValid, valid => valid === false)
}
